import { NotesListBaseDataProvider } from './NotesListBaseDataProvider';
import { CreateNoteRequest, DeleteNoteRequest, UpdateNoteRequest } from '../types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { Note } from '../../types';

export class NotesListGzDataProvider extends NotesListBaseDataProvider {
  public async getNotes(): Promise<Note[]> {
    const notes = await ConsoleRequest.createRequest<any[]>({
      dataProviderType: DataProviderType.CORE,
      endpoint: this.dependencies.api.modelName,
      method: 'readNotes',
      payload: {
        [this.getResourceIdApiField()]: this.dependencies.resourceId,
      },
    });

    return this.buildDataForView(notes);
  }

  public async createNote(request: CreateNoteRequest): Promise<void> {
    await ConsoleRequest.createRequest<void>({
      dataProviderType: DataProviderType.CORE,
      endpoint: this.dependencies.api.modelName,
      method: 'createNote',
      payload: {
        text: request.text,
        [this.getResourceIdApiField()]: this.dependencies.resourceId,
      },
    });
  }

  public async updateNote(request: UpdateNoteRequest): Promise<void> {
    await ConsoleRequest.createRequest<void>({
      dataProviderType: DataProviderType.CORE,
      endpoint: this.dependencies.api.modelName,
      method: 'updateNote',
      payload: {
        id: request._id,
        text: request.text,
      },
    });
  }

  public async deleteNote(request: DeleteNoteRequest): Promise<void> {
    await ConsoleRequest.createRequest<void>({
      dataProviderType: DataProviderType.CORE,
      endpoint: this.dependencies.api.modelName,
      method: 'deleteNote',
      payload: {
        id: request._id,
      },
    });
  }
}
